<template>
  <div class="container page bind-page">
    <van-nav-bar :title="uiText.title" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back" />
      </template>
    </van-nav-bar>

    <div class="page-body">
      <p class="intro">{{ uiText.intro }}</p>

      <div class="form-card">
        <div class="form-row">
          <span class="label">{{ uiText.network }}</span>
          <div class="field-wrap">
            <van-field
              v-model="network"
              :placeholder="uiText.networkPlaceholder"
            />
          </div>
        </div>

        <div class="form-row address-row">
          <span class="label">{{ uiText.address }}</span>
          <div class="address-field">
            <van-field
              v-model="usdt"
              :placeholder="$t('my.msg43')"
            />
          </div>
          <div class="copy-pill" @click="copyAddress">{{ uiText.copy }}</div>
        </div>

        <div class="form-row">
          <span class="label">{{ uiText.storage }}</span>
          <div class="field-wrap">
            <van-field
              v-model="storageName"
              :placeholder="uiText.storageHint"
            />
          </div>
        </div>
      </div>

      <p class="warn">{{ $t("setting.bank_warn") }}</p>

      <div class="submit-btn" @click="bindAddress">{{ uiText.confirm }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usdt: "",
      network: "",
      storageName: "",
      userInfo: {},
    };
  },
  computed: {
    uiText() {
      const lang = this.$t("auth.lang");
      const copy = {
        zh: {
          title: "链接银行账号",
          intro: "请输入您的加密货币账户信息",
          network: "选择网络",
          networkPlaceholder: "请输入网络名称",
          address: "地址",
          storage: "Name",
          storageHint: "请输入您的存款名称",
          copy: "复制",
          confirm: "确认账户关联账号",
        },
        en: {
          title: "Link Withdrawal Address",
          intro: "Please enter your crypto account information",
          network: "Network",
          networkPlaceholder: "Please enter a network",
          address: "Address",
          storage: "Name",
          storageHint: "Saved with current address only",
          copy: "Copy",
          confirm: "Confirm Address Binding",
        },
        ja: {
          title: "出金アドレスを連携",
          intro: "暗号資産アカウント情報を入力してください",
          network: "ネットワーク",
          networkPlaceholder: "ネットワークを入力してください",
          address: "アドレス",
          storage: "Name",
          storageHint: "現在のアドレスに保存されます",
          copy: "コピー",
          confirm: "アカウント連携を確認",
        },
        kr: {
          title: "출금 주소 연결",
          intro: "암호화폐 계정 정보를 입력해 주세요",
          network: "네트워크",
          networkPlaceholder: "네트워크를 입력해 주세요",
          address: "주소",
          storage: "Name",
          storageHint: "현재 주소로 저장됩니다",
          copy: "복사",
          confirm: "계정 연결 확인",
        },
      };

      return copy[lang] || copy.zh;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    copyAddress() {
      if (!this.usdt) {
        this.$toast(this.$t("my.msg43"));
        return;
      }

      const input = document.createElement("input");
      input.value = this.usdt;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$toast(this.uiText.copy);
    },
    bindAddress() {
      if (this.network === "") {
        this.$toast(this.uiText.networkPlaceholder);
        return false;
      }
      if (this.usdt === "") {
        this.$toast(this.$t("my.msg43"));
        return false;
      }
      if (this.storageName === "") {
        this.$toast(this.uiText.storageHint);
        return false;
      }

      this.$http({
        method: "post",
        data: {
          network: this.network,
          usdt: this.usdt,
          warehouse: this.storageName,
        },
        url: "user_set_usdt",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.$router.replace({ path: this.$route.query.redirect || "/Withdraw" });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return true;
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (!this.userInfo.paypassword) {
            this.$router.replace({ path: "/SetPayPassword", query: { redirect: "/BindUsdt" } });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200 && res.data.info) {
          this.usdt = res.data.info.usdt || "";
          this.network = res.data.info.network || "";
          this.storageName = res.data.info.warehouse || "";
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.bind-page {
  min-height: 100vh;
  background: #fff;
}

.nav-bar {
  background: #fff;
}

.nav-bar ::v-deep .van-nav-bar__title,
.nav-bar ::v-deep .van-icon {
  color: #333;
}

.page-body {
  padding: 30px 14px 48px;
}

.intro {
  margin: 0 0 34px;
  font-size: 36px;
  color: #666;
}

.form-card {
  background: #fff;
}

.form-row {
  display: flex;
  align-items: center;
  min-height: 78px;
  border-bottom: 1px solid #f3f3f3;
}

.label {
  width: 108px;
  font-size: 28px;
  color: #666;
}

.value {
  flex: 1;
  font-size: 28px;
  color: #bbb;
}

.muted {
  color: #c7c7c7;
}

.field-wrap {
  flex: 1;
}

.field-wrap ::v-deep .van-cell {
  padding: 0;
  background: transparent;
}

.field-wrap ::v-deep input {
  font-size: 28px;
}

.address-row {
  align-items: center;
}

.address-field {
  flex: 1;
}

.address-field ::v-deep .van-cell {
  padding: 0;
  background: transparent;
}

.address-field ::v-deep input {
  font-size: 28px;
}

.copy-pill {
  margin-left: 10px;
  min-width: 76px;
  height: 46px;
  line-height: 46px;
  border-radius: 23px;
  background: #e99bb6;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #fff;
}

.warn {
  margin: 40px 0 0;
  font-size: 32px;
  line-height: 1.65;
  color: #df5151;
}

.submit-btn {
  margin-top: 44px;
  width: calc(100% - 50px);
  height: 88px;
  line-height: 88px;
  border-radius: 44px;
  background: #e99bb6;
  font-size: 34px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
}
</style>
